var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-datatable-wrapper"},[_c('sf-data-table',{ref:"dataTable",staticStyle:{"height":"230px"},attrs:{"scrId":_vm.scrId,"paging":false,"columns":_vm.columns,"rows":_vm.rows,"stripe":false,"selection":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }